'use client';

import { Suggestions } from '@/components/terminal/Suggestions';
import { Input } from '@/components/terminal/Input';
import { useState } from 'react';
import { AiTerminalIcon } from '@/icons';
import { PromptExamples } from '@/types/terminal';

export const AITerminalWidget = ({
  onPromptSubmit,
  suggestions,
}: {
  onPromptSubmit: (input: string) => void;
  suggestions: PromptExamples;
}) => {
  const [prompt, setPrompt] = useState('');

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      onPromptSubmit(prompt);
    }
  };

  return (
    <div className="w-full flex flex-col gap-y-4 p-4 sm:p-7 rounded-2xl bg-grey-800 border border-grey-850">
      <div className="flex gap-x-2 items-center">
        <AiTerminalIcon className="text-yellow-500 w-6 h-6" />
        <h3 className="text-lg font-sans font-semibold bg-gradient-to-r from-yellow-500 to-sky-600 text-transparent bg-clip-text">
          AI Terminal
        </h3>
      </div>
      <Suggestions isWidget suggestions={suggestions} onSelect={onPromptSubmit} />
      <Input
        placeholder="Message the AI Terminal"
        actions={suggestions}
        prompt={prompt}
        setPrompt={setPrompt}
        handleKeyDown={handleKeyDown}
        className="bg-grey-450"
        inputClassName="placeholder:text-neutral-100"
      />
    </div>
  );
};
